export interface IBasketData {
    basketId?: string;
    creationTime?: number;
    basketName?: string;
    ownerId: string;
    productList: Array<IBasketItem>;
    branchId: string;
    subTotal?: number;
    grandTotal?: number;
    bogoDiscount?: number;
    cartDiscount?: number;
    couponCodeList?: string[];
    id?: string;
    saleID?: string;
}

export interface IBasket extends IBasketData {
    data(): IBasketData
}

export interface IBasketItem {
    sku: number;
    quantity: number;
}
export class BasketItem implements IBasketItem {
    sku: number;
    quantity: number;
    constructor(data: IBasketItem) {
        this.sku = data.sku
        this.quantity = data.quantity
    }
}